import { ITableSet } from "./Table";
import { useEffect, useState } from 'react';


export enum SortType {
    NONE,
    OBVERSE,
    REVERSE
}

function getSet(key: string, tableSets: ITableSet[]) {
    for (let set of tableSets) {
        if (set.key === key) {
            return set;
        }
    }
    return null;
}

function useSort(data: any[], tableSets: ITableSet[]) {

    const [type, setType] = useState(SortType.NONE);
    const [sortTitle, setSortTitle] = useState("");
    const [dataShow, setDataShow] = useState(data);

    useEffect(() => {
        setType(SortType.NONE);
        setSortTitle("");
        setDataShow(data);
    }, [data]);

    const handleSort = (key: string) => {
        let set = getSet(key, tableSets);
        if (set && set.handleSort) {
            if (type === SortType.OBVERSE) {
                dataShow.sort((a, b) => {
                    return -set!.handleSort!(a[key], b[key]);
                });
                setType(SortType.REVERSE);
            } else {
                dataShow.sort((a, b) => {
                    return set!.handleSort!(a[key], b[key]);
                });
                setType(SortType.OBVERSE);
            }

            setSortTitle(key);
            setDataShow(dataShow);
        }
    }

    const getType = (key?: string) => {
        if (!key) return SortType.NONE;
        if (key !== sortTitle) return SortType.NONE;
        return type;
    }

    return [dataShow, getType, handleSort] as [any[], (key?: string) => SortType, (key?: string) => void];
}

export default useSort;